import { ROUTES } from "./url";

export const PAGE_CONTEXT: { [key: string]: string } = {
    [ROUTES.DASHBOARD.url]: "dashboard",
    [ROUTES.ANALYTICS.url]: "analytics",
    [ROUTES.PRODUCTS.url]: "products",
    [ROUTES.FEATURE.url]: "feature",
    [ROUTES.SUPPORT.url]: "support",
    [ROUTES.SUPPORT.subRoutes.SERVICE_REQUESTS.url]: "support_service_requests",
    [ROUTES.SUPPORT.subRoutes.CUSTOMERS.url]: "support_customers",
    [ROUTES.SUPPORT.subRoutes.CUSTOMERS.subRoutes.ACCOUNTS.url]: "support_customers_accounts",
    [ROUTES.SUPPORT.subRoutes.INSTITUTIONS.url]: "support_institutions",
    [ROUTES.SUPPORT.subRoutes.NOTIFICATIONS.url]: "support_notifications",
    [ROUTES.SUPPORT.subRoutes.SITES.url]: "support_sites",
    [ROUTES.SETTINGS.url]: "settings",
    [ROUTES.SETTINGS.subRoutes.PERMISSIONS.url]: "settings_permissions",
    [ROUTES.SETTINGS.subRoutes.SYSTEM_SETTINGS.url]: "settings_system_settings",
    [ROUTES.INTERNAL_TOOLS.subRoutes.YODLEE_CUSTOMERS.url]: "yodlee_customers",
    [ROUTES.INTERNAL_TOOLS.subRoutes.ONBOARDING.url]: "onboarding",
    [ROUTES.INTERNAL_TOOLS.subRoutes.SITE_METADATA.url]: "siteMetadata",
    [ROUTES.INTERNAL_TOOLS.subRoutes.ASK_YODLEE_ADMIN_PORTAL.url]: "askYodleeAdminPortal",
    [ROUTES.INTERNAL_TOOLS.subRoutes.NOTIFICATIONS.url]: "notifications",
    [ROUTES.MY_ACCOUNT.url]: "my_account",
    [ROUTES.STATUS.url]: "status",
}